import Login from "@/components/login/login";

export const login = [
    {path: '/login', name: 'login', component: Login}
]